module.exports = __webpack_public_path__ + "img/article_2_3.e8831546.png";